import { render, staticRenderFns } from "./OngletResa.vue?vue&type=template&id=1e65f7ba"
import script from "./OngletResa.vue?vue&type=script&lang=js"
export * from "./OngletResa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports